import { render, staticRenderFns } from "./ShowNftDetails.vue?vue&type=template&id=0dcf9b23&"
import script from "./ShowNftDetails.vue?vue&type=script&lang=js&"
export * from "./ShowNftDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports